<template>
<div class="mt-auto text-center wrp-footer">
    <hr class="one"/>
    <h6 class="text-white font-weight-light">© 2019 Financio, an ABSS company</h6>

  <b-link  class="link-small" >
     <a class="one text-white font-weight-light"  href="#" >Privacy Policy</a>
  </b-link>


</div>
</template>

<script>
export default {}
</script>
